const METRIC_PAGE_TAB = 2;

export const getMetricTabs = (isMobile: boolean): string[] => {
  if (isMobile) {
    return ['Cotizaciones'];
  }
  return ['Cotizaciones', 'Métricas'];
};

export const showSearchElements = (page: number): boolean =>
  page !== METRIC_PAGE_TAB;

export default getMetricTabs;
